import React, { FC } from 'react';
import { Modal } from '@mui/material';
import { FilterHeader20 } from '../../base/FilterHeader20';
import { Person } from '../../VisitReportPage/Person';
import './styled.scss';
import {BlackButton} from '../../HomePage/BlackButton';
import { LeftTown } from '../../VisitReportPage/VisitReportModal/childrens/LeftTown';
import { PhoneNumberInputWithType } from '../../CreateHouseholdPage/PhoneNumberInputWithType';
import { useTranslation } from '../../../hooks/useTranslation';

interface IUpdatedPersonNotificationProps {
    formik: any
    isVisible: boolean,
    setIsVisible: () => void;
    salutations: string[]
    addressesTypes: string[]
    // Household HOME details staged with the same notification, surfaced here so the admin
    // reviews contact AND home changes together in one consolidated panel.
    hasStagedPhone?: boolean
    hasStagedAddress?: boolean
    contacts?: { id: number; full_name: string }[]
}

export const UpdatedPersonNotification:
    FC<IUpdatedPersonNotificationProps> = ({
                                               isVisible,
                                               setIsVisible,
                                               formik,
                                               salutations,
                                               addressesTypes,
                                               hasStagedPhone = false,
                                               hasStagedAddress = false,
                                               contacts = [] }) => {
    const { p: pContact } = useTranslation('contact_info');
    const { p: pNotif } = useTranslation('notifications');

    return(
        <Modal
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }}
            open={isVisible}>
            <div className="update-person-notification__modal">
                <FilterHeader20 title={pNotif('changed_contact_info_title')} onClose={setIsVisible} />
                <div className='update-person-notification__modal__body'>
                    {/* Household HOME details (house phone + home-address correction) staged with
                        this notification, visually separated from the contact edits below — the
                        two are unrelated changes bundled into one confirmation. */}
                    {(hasStagedPhone || hasStagedAddress) && (
                        <div className="update-person-notification__modal__section-title">
                            {pContact('home_details')}
                        </div>
                    )}
                    {hasStagedPhone && (
                        <div className="notification__house-phone">
                            <PhoneNumberInputWithType
                                label={pContact('house_phone')}
                                type="Home"
                                index="house"
                                value={formik.values.house_phone ?? ''}
                                hideTypeSelect
                                hideDelete
                                onChange={(value: string) => formik.setFieldValue('house_phone', value)}
                                onTypeChange={() => undefined}
                                onDeletePhone={() => undefined}
                            />
                        </div>
                    )}
                    {hasStagedAddress && (
                        <LeftTown
                            openLeftTown
                            lockHomeType
                            // This is a "Update contact info" home-address CORRECTION (household
                            // did NOT move) — its own independent field, never `new_address`
                            // (which is Left Town ONLY, a household MOVE).
                            fieldName="updated_home_address"
                            formik={formik as any}
                            setOpenLeftTown={() => {}}
                            addressesTypes={addressesTypes}
                            contacts={contacts}
                        />
                    )}
                    {(formik.values.updated_persons || []).length > 0 && (
                        <div className="update-person-notification__modal__section-title">
                            {pContact('contacts')}
                        </div>
                    )}
                    {(formik.values.updated_persons || []).map((_: any, index: number) => (
                        <Person
                            isUpdate
                            key={index}
                            formik={formik}
                            personIndex={index}
                            salutations={salutations}
                            addressesTypes={addressesTypes}
                        />
                    ))}
                </div>
                <div className='update-person-notification__modal__footer'>
                    <div className="update-person-notification__modal__button_wrapper">
                        <BlackButton title={'Save + Confirm Changes'} onClick={formik.handleSubmit} />
                    </div>
                </div>
            </div>
        </Modal>
    )
}
